/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Inventory_Hold_DescriptionInputs */

const en_create_inventory_hold_description = /** @type {(inputs: Create_Inventory_Hold_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place a temporary manual hold. Contract draft holds already reduce available inventory immediately.`)
};

const es_create_inventory_hold_description = /** @type {(inputs: Create_Inventory_Hold_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un apartado manual temporal. Los borradores de contrato ya reducen el inventario disponible inmediatamente.`)
};

/**
* | output |
* | --- |
* | "Place a temporary manual hold. Contract draft holds already reduce available inventory immediately." |
*
* @param {Create_Inventory_Hold_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_inventory_hold_description = /** @type {((inputs?: Create_Inventory_Hold_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Inventory_Hold_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_inventory_hold_description(inputs)
	return es_create_inventory_hold_description(inputs)
});